import MuiCheckbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import styled from 'styled-components';

export const Cb = styled(MuiCheckbox)`
    color: ${(props) => props.theme.palette.primaryA1};
    position: absolute;

    .MuiSvgIcon-root {
        color: ${(props) => props.theme.palette.primaryA1};
    }

    &.Mui-checked {
        color: ${(props) => props.theme.palette.primaryA1};
    }

    &.Mui-disabled {
        opacity: 0.5;
    }
`;

export const FormControlLabelStyled = styled(FormControlLabel)`
    margin-right: 0;
    position: relative;
    &:before {
        content: '';
        width: 42px;
        height: 24px;
    }
`;
